"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class TenantApi extends runtime.BaseAPI {
    /**
     * To confirm this, pass the value YES in the confirm property. THIS CANNOT BE REVERSED. This is only available to tenant owners.
     */
    apiTenantDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.confirm !== undefined) {
                queryParameters['confirm'] = requestParameters.confirm;
            }
            if (requestParameters.tenants !== undefined) {
                queryParameters['tenants'] = requestParameters.tenants;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Tenant`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EraseResponseFromJSON(jsonValue));
        });
    }
    /**
     * To confirm this, pass the value YES in the confirm property. THIS CANNOT BE REVERSED. This is only available to tenant owners.
     */
    apiTenantDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantDeleteRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiTenantGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Tenant`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ITenantIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiTenantGetSubscriptionsPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Tenant/GetSubscriptions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GroupUsageResponseIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantGetSubscriptionsPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantGetSubscriptionsPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Only populates all profiles and active profiles
     */
    apiTenantGetUsageMonthPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Tenant/GetUsage/Month`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiMonthRequestToJSON(requestParameters.apiMonthRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TenantUsageResponseFromJSON(jsonValue));
        });
    }
    /**
     * Only populates all profiles and active profiles
     */
    apiTenantGetUsageMonthPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantGetUsageMonthPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiTenantGetUsagePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Tenant/GetUsage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiRequestToJSON(requestParameters.apiRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TenantUsageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantGetUsagePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantGetUsagePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiTenantGetUserPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Tenant/GetUser`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiQueryRequestToJSON(requestParameters.apiQueryRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UserPersonResponseIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantGetUserPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantGetUserPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiTenantPingGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Tenant/Ping`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     */
    apiTenantPingGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantPingGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiTenantPingHeadRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Tenant/Ping`,
                method: 'HEAD',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     */
    apiTenantPingHead() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantPingHeadRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiTenantPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Tenant`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TenantConstructToJSON(requestParameters.tenantConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ITenantIStorableIDataSecurableResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiTenantTicketingFeesGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Tenant/TicketingFees`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ITicketingFeesIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantTicketingFeesGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantTicketingFeesGetRaw();
            return yield response.value();
        });
    }
    /**
     */
    apiTenantTicketingFeesPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Tenant/TicketingFees`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TicketingFeesConstructToJSON(requestParameters.ticketingFeesConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ITicketingFeesIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantTicketingFeesPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantTicketingFeesPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiTenantUsersGetRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Tenant/Users`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GuidStringDictionaryIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiTenantUsersGet() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiTenantUsersGetRaw();
            return yield response.value();
        });
    }
}
exports.TenantApi = TenantApi;
